import React from 'react';
import { Target, ArrowUpRight } from 'lucide-react';

export default function ActionLeaderboard({ actions = [], siteConfig }) {
  // Map actions with declarative site config labels if defined
  const configActionMap = new Map();
  if (siteConfig?.conversionActions) {
    for (const act of siteConfig.conversionActions) {
      configActionMap.set(act.event, act);
    }
  }

  const formatActionLabel = (type) => {
    if (!type) return 'Unknown Action';
    if (/^\d+$/.test(type)) {
      return `Artwork #${type}`;
    }
    return String(type)
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const list = actions.map((a) => {
    const conf = configActionMap.get(a.action_type);
    return {
      type: a.action_type,
      label: conf?.label || formatActionLabel(a.action_type),
      color: conf?.color || '#3b82f6',
      count: Number(a.count || 0),
      visitors: Number(a.unique_visitors || 0),
    };
  });

  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-4 sm:p-5 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white flex items-center gap-1.5">
            <Target className="w-4 h-4 text-indigo-500" />
            Conversion & Feature Actions
          </h3>
          <p className="text-[11px] text-slate-500 dark:text-slate-400">
            High-intent product interactions & outbound exits
          </p>
        </div>
      </div>

      {list.length === 0 ? (
        <div className="py-6 text-center text-xs text-slate-400">
          No conversion events recorded in this timeframe.
        </div>
      ) : (
        <div className="divide-y divide-slate-100 dark:divide-slate-800">
          {list.map((item, idx) => (
            <div key={idx} className="py-2.5 flex items-center justify-between gap-3 text-xs">
              <div className="flex items-center gap-2 min-w-0">
                <span
                  className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <span className="font-semibold text-slate-800 dark:text-slate-200 truncate capitalize">
                  {item.label}
                </span>
                <span className="text-[10px] text-slate-400 font-mono">
                  ({item.type})
                </span>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="text-right">
                  <div className="font-mono font-bold text-slate-900 dark:text-white tabular-nums">
                    {item.count.toLocaleString()}
                  </div>
                  <div className="text-[10px] text-slate-400">
                    {item.visitors} {item.visitors === 1 ? 'user' : 'users'}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
